<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M9.9974 8.33463C11.8383 8.33463 13.3307 6.84225 13.3307 5.0013C13.3307 3.16035 11.8383 1.66797 9.9974 1.66797C8.15645 1.66797 6.66406 3.16035 6.66406 5.0013C6.66406 6.84225 8.15645 8.33463 9.9974 8.33463Z"
      fill="currentColor"
    />
    <path
      d="M6.66542 10.2109C4.9229 10.2109 3.4562 11.5152 3.25261 13.2458L2.71137 17.8463C2.67104 18.189 2.91625 18.4997 3.25906 18.54C3.60188 18.5804 3.91248 18.3351 3.95281 17.9923L4.49404 13.3919C4.59827 12.5059 5.22281 11.7955 6.04042 11.5518V15.0459C6.0404 15.7947 6.04038 16.419 6.10701 16.9147C6.17736 17.4379 6.33208 17.9102 6.71164 18.2897C7.0912 18.6693 7.56353 18.824 8.08669 18.8944C8.58236 18.961 9.2067 18.9609 9.95536 18.9609H10.0421C10.7908 18.9609 11.4152 18.961 11.9109 18.8944C12.4339 18.824 12.9063 18.6693 13.2859 18.2897C13.6654 17.9102 13.8202 17.4379 13.8905 16.9147C13.9571 16.419 13.9571 15.7947 13.9571 15.0459V11.5518C14.7747 11.7955 15.3993 12.5059 15.5034 13.3919L16.0447 17.9923C16.085 18.3351 16.3956 18.5804 16.7384 18.54C17.0813 18.4997 17.3264 18.189 17.2861 17.8463L16.7449 13.2458C16.5413 11.5152 15.0746 10.2109 13.3321 10.2109H6.66542Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'ConsultantsIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>